<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="userOperate">
        <el-input v-model="filter.userName" placeholder="请输入用户名" clearable style="float: left;"></el-input>
        <el-input v-model="filter.userPhone" placeholder="请输入手机号" clearable style="float: left;"></el-input>
        <el-input v-model="filter.orderNumber" placeholder="请输入订单编号" clearable style="float: left;"></el-input>
        <el-select placeholder="请选择状态" v-model="filter.status" clearable style="float: left;">
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"/>
        </el-select>
        <el-button @click="_getList" type="primary" style="float: left;">搜索</el-button>
        <el-pagination background layout="prev, pager, next" :current-page="pageNum"
                       @current-change="pageChange"
                       :total="totalNum" v-if="paginationShow"></el-pagination>

      </div>
      <div class="categoryTable">
        <el-table ref="multipleTable" :data="list" tooltip-effect="dark" style="width: 100%" border>
          <el-table-column prop="userName" label="用户名" />
          <el-table-column prop="userPhone" label="手机号" />
          <el-table-column prop="itemNumber" label="子订单编号" />
          <el-table-column prop="orderNumber" label="订单编号" />
          <el-table-column prop="skuTitle" label="商品名称" />
          <el-table-column prop="price" label="商品价格" />
          <el-table-column prop="startDate" label="开始释放日期" />
          <el-table-column prop="releaseRounds" label="释放总轮数" />
          <el-table-column prop="currentRounds" label="已释放轮数" />
          <el-table-column prop="eachRoundAmount" label="每轮释放金额" />
          <el-table-column prop="status" label="状态" width="120">
            <template slot-scope="scope">
              <span>{{ getStatus(scope.row.status) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="insertTime" label="创建时间" >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {Loading} from 'element-ui'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
import {getBusinessSubsidiesRecord} from 'api/request'
import {ERR_OK} from 'api/config'
import {loadingInstance, Error} from 'common/js/util'

export default {
  components: {MSidebar, MHeader},
  data () {
    return {
      pageSize: 10,
      pageNum: 1,
      totalNum: 0,
      paginationShow: false,
      list: [],
      filter:{
        userName:'',
        userPhone:'',
        orderNumber:'',
        status:'',
      },
      statusList:[
        {value:"",label:'请选择'},
        {value:0,label:'待释放'},
        {value:1,label:'释放中'},
        {value:2,label:'已完成'}
      ]
    }
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'))
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    } else {
      this._getList()
    }
  },
  methods: {
    getStatus (status) {
      if(status == 0) return "待释放";
      if(status == 1) return "释放中";
      if(status == 2) return "已完成";
      return "-";
    },
    // 点击分页
    pageChange (val) {
      this.pageNum = val
      this._getList()
    },
    // 获取列表
    _getList () {
      let param = {
        current: this.pageNum,
        size: this.pageSize,
        userName: this.filter.userName,
        userPhone: this.filter.userPhone,
        orderNumber: this.filter.orderNumber,
      }
      if (this.filter.status !== '') {
        param.status = this.filter.status
      }
      loadingInstance(Loading)
      getBusinessSubsidiesRecord(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.list = res.data.records
          this.totalNum = res.data.total
          if (res.data.pages > 1) {
            this.paginationShow = true
          }
        } else {
          Error(this, res)
        }
      })
    }
  }
}
</script>
<style scoped>
.userOperate{
  height: 50px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 30px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.userOperate .el-input {
  width:180px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}
.userOperate .el-button {
  width:100px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}

.categoryOperate {
  height: 40px;
  margin: 20px;
  box-sizing: border-box;
}

.categoryTable {
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
}
</style>
<style>
.el-tag + .el-tag {
  margin: 5px;
}

.categoryOperate .el-input {
  width: 180px;
  height: 40px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}

.categoryOperate .el-button {
  width: 100px;
  height: 40px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/finance/businessSubsidiesRecord.vue